import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useNavigate } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ToggleSwitch from './ToggleSwitch'
import burgermenu_000000 from '../media/burgermenu_000000.svg';
import burgermenu_f7a823 from '../media/burgermenu_f7a823.svg';
import './Header.css';

class Header extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {isMenuToggled: false};
        this.toggleMenu = this.toggleMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.openHome = this.openHome.bind(this);
        this.handleLanguageSwitchCheck = this.handleLanguageSwitchCheck.bind(this);
        document.body.classList.toggle("navbar-active", false);
    }

    toggleMenu() {
        document.body.classList.toggle("navbar-active", this.state.isMenuToggled === false);
        this.setState(prevState => ({
            isMenuToggled: !prevState.isMenuToggled
        }));
    }

    closeMenu() {
        document.body.classList.toggle("navbar-active", false);
        this.setState(prevState => ({
            isMenuToggled: false
        }));
    }

    openHome() {
        this.props.navigate('/');
    }

    handleLanguageSwitchCheck(value) {
        let language = 'de';
        if (value === true) {
            language = 'en';
        }
        let onLanguage = this.props.onLanguage;
        if (onLanguage && typeof onLanguage === 'function') {
            onLanguage(language);
        }
    }

    render() {
        let languageSwitchChecked = false;
        if (this.props.language && this.props.language.length > 0 && this.props.language !== 'de') {
            languageSwitchChecked = true;
        }
        return (
            <header className="App-header">
                <div className="App-header-logo">
                    <img src="/images/logos/HE.svg" alt="logo" onClick={this.openHome} />
                    <span className="eurostile-condensed-heavy" onClick={this.openHome}>VERKEHRSLEHRMITTEL GmbH</span>
                </div>
                <div className={`App-header-burgermenu${this.state.isMenuToggled ? ' active' : ''}`} onClick={this.toggleMenu}>
                    <img src={burgermenu_000000} className="normal" alt="burgermenu" />
                    <img src={burgermenu_f7a823} className="hover" alt="burgermenu-hover" />
                </div>
                <nav className={`App-header-navbar${this.state.isMenuToggled ? ' active' : ''}`}>
                    <div className="App-header-navbar-before">
                        <div className="App-header-navbar-before-inner"></div>
                    </div>
                    <div className="App-header-navbar-inner">
                    <ul>
                            <li className="App-header-navbar-li-home">
                                <NavLink to="/home" onClick={this.closeMenu}>{this.props.t('Common.Home')}</NavLink>
                            </li>
                            <br className="App-header-navbar-br-home" />
                            <li className="App-header-navbar-li-heindia">
                                <NavLink to="/heindia" onClick={this.closeMenu}>{this.props.t('Common.HEIndia')}</NavLink>
                            </li>
                            <br className="App-header-navbar-br-heindia" />
                            <li className="App-header-navbar-li-references">
                                <NavLink to="/references" onClick={this.closeMenu}>{this.props.t('Common.Customers')}</NavLink>
                            </li>
                            <br className="App-header-navbar-br-references" />
                            <li className="App-header-navbar-li-placeholder">
                            </li>
                            <br className="App-header-navbar-br-placeholder" />
                            <li className="App-header-navbar-li-services">
                                <NavLink to="/services" onClick={this.closeMenu}>{this.props.t('Common.Service')}</NavLink>
                            </li>
                            <br className="App-header-navbar-br-services" />
                            <li className="App-header-navbar-li-project">
                                <NavLink to="/project" onClick={this.closeMenu}>{this.props.t('Common.Project')}</NavLink>
                            </li>
                            <br className="App-header-navbar-br-project" />
                            <li className="App-header-navbar-li-contact">
                                <NavLink to="/contact" onClick={this.closeMenu}>{this.props.t('Common.Contact')}</NavLink>
                            </li>
                        </ul>
                        <div className="App-header-navbar-language">
                            <ToggleSwitch id="languageswitch" value1="DE" value2="EN" checked={languageSwitchChecked} onCheck={this.handleLanguageSwitchCheck} />
                        </div>
                    </div>
                </nav>
            </header>
        );
    }
}

export default withTranslation()(function HeaderUseNavigate(props) {
    const navigate = useNavigate();
    return <Header {...props} navigate={navigate} />
})

Header.defaultProps = {
    language: 'de',
    onLanguage: undefined
};

Header.propTypes = {
    language: PropTypes.string,
    onLanguage: PropTypes.func
};